// ═══════════════════════════════════════════════════════════
// src/hooks/useAuth.js
// Hook centralisé — à importer dans App.jsx uniquement
// ═══════════════════════════════════════════════════════════

import { useState, useEffect } from 'react'
import { onAuthStateChanged, signOut } from 'firebase/auth'
import { FirebaseAuthentication, isNativeGoogleAvailable } from '../utils/nativeGoogleAuth'
import { auth } from '../firebase/config'

export function useAuth() {
  const [currentUser, setCurrentUser] = useState(undefined) // undefined = chargement
  const [loadingAuth, setLoadingAuth] = useState(true)

  useEffect(() => {
    // Écoute Firebase Auth en temps réel sur TOUS les supports
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      console.log('🔐 Auth:', user ? `connecté → ${user.email}` : 'non connecté')
      setCurrentUser(user)
      setLoadingAuth(false)
    })
    return () => unsubscribe()
  }, [])

  const handleLogout = async () => {
    try {
      await signOut(auth)
      // Déconnecte aussi le compte Google natif (Android), sinon le
      // prochain "Continuer avec Google" reprendrait le même compte
      if (isNativeGoogleAvailable()) {
        try {
          await FirebaseAuthentication.signOut()
        } catch { /* rien à faire */ }
      }
      // On garde les préférences d'affichage (taille du texte…)
      const prefs = localStorage.getItem('johnnyPrefs')
      localStorage.clear()
      if (prefs) localStorage.setItem('johnnyPrefs', prefs)
    } catch (error) {
      console.error('❌ Erreur déconnexion:', error)
    }
  }

  return { currentUser, loadingAuth, handleLogout }
}
